import { render } from "./CommentDialog.vue?vue&type=template&id=6750326b&scoped=true"
import script from "./CommentDialog.vue?vue&type=script&lang=js"
export * from "./CommentDialog.vue?vue&type=script&lang=js"

import "./CommentDialog.vue?vue&type=style&index=0&id=6750326b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6750326b"]])

export default __exports__